import smores from "../lesson-images/smoreslesson.jpg";
import signs from "../lesson-images/signslesson.jpg";
import colorsplash from "../lesson-images/colorsplash.png";
import goache from "../lesson-images/goache.jpg";
import henna from "../lesson-images/henna.jpeg";
import scratchboard from "../lesson-images/scratchboard.jpg";
import pastel from "../lesson-images/pastelPortrait.jpg";
import vinyl from "../lesson-images/vinyl.jpeg";
import poptarts from "../lesson-images/poptart.png";
import howToMakeAGif from "../lesson-images/howToMakeAGif.png";
import whatIsAPencilMadeOf from "../lesson-images/whatIsAPencilMadeOf.png";
import LessonCard from "./lessonCard";
import { LessonId } from "../enums/lessonId";
import { useEffect } from "react";

const Lessons = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
    });
    
    return (
        <div className="py-5">
            <div className="container">
                <div className="row g-4 d-flex align-content-center justify-content-center">
                    <LessonCard image={colorsplash} title={'Color Splash'} lessonId={LessonId.colorsplash} />
                    <LessonCard image={signs} title={'Neon Signs'} lessonId={LessonId.neonsigns} />
                    <LessonCard image={goache} title={'Goache'} lessonId={LessonId.goache} />
                    <LessonCard image={henna} title={'Henna'} lessonId={LessonId.henna} />
                    <LessonCard image={scratchboard} title={'Scratchboard'} lessonId={LessonId.scratchboard} />
                    <LessonCard image={smores} title={'Model Magic S\'mores'} lessonId={LessonId.smores} />
                    <LessonCard image={pastel} title={'Pastel Portrait'} lessonId={LessonId.pastelPortrait} />
                    <LessonCard image={vinyl} title={'Vinyl'} lessonId={LessonId.vinyl} />
                    <LessonCard image={poptarts} title={'PopTarts'} lessonId={LessonId.poptarts} />
                    <LessonCard image={howToMakeAGif} title={'How To Make a Gif'} lessonId={LessonId.howtomakeagif} />
                    <LessonCard image={whatIsAPencilMadeOf} title={'What is a pencil made of?'} lessonId={LessonId.whatisapencilmadeof} />
                </div>
            </div>
        </div>
    )
};

export default Lessons;
